export const theme = {
  font: {
    thin: 300,
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 800,
  },
  color: {
    black: '#111111',
    blue: '#3498DB',
  },
  media: {
    phone: '@media (max-width: 430px)',
    tablet: '@media (max-width: 768px)',
    desktop: '@media (min-width: 1024px)',
  }
}
